export default {
  MR: "Herr",
  MRS: "Frau",
  OTHER: "-"
};
